export const AGENTS_SEARCH_LIMIT = 20
export const ALL_AGENTS_ID = 'ALL' // TODO: need to write a util for conversion GraphQL enum (need both from & to utils)

export const CALL_LOGS_LIST_SCROLL_TARGET_ID = 'CALL_LOGS_LIST_SCROLL_TARGET_ID'
export const CALL_LOGS_PAGINATION_LIMIT = 15

export const CALL_LOG_STARTED_AT_FORMAT = 'D MMM YYYY - hh:mm A'

export const DEFAULT_INVALID_NAME_VALUE = '--'

export enum CallLogTypeEnum {
   All = 'ALL',
   MISSED = 'MISSED'
}
